import { TableInstance } from "react-table";
import { TableRow } from "./TableRow";

type ITableBodyProps<T extends object> = {
  page: TableInstance<T>["page"];
  getTableBodyProps: TableInstance<T>["getTableBodyProps"];
  visibleColumns: TableInstance<T>["visibleColumns"];
  prepareRow: TableInstance<T>["prepareRow"];
  isLoading: boolean;
  onRowClick?: (row: T) => void;
  isChildTable?: boolean;
  erroredColumns?: { column: string; indices: number[] }[];
};

// The body has no scroll viewport of its own — it grows to its content height
// and the TableScrollContainer scrolls both axes with native scrollbars (the
// header stays visible via position: sticky).
export const TableBody = <T extends object>({
  getTableBodyProps,
  prepareRow,
  page,
  onRowClick,
  erroredColumns,
}: ITableBodyProps<T>) => {
  const rows = page.map((row, i) => {
    prepareRow(row);
    return (
      <TableRow
        row={row}
        key={i}
        onRowClick={onRowClick}
        erroredColumns={erroredColumns}
      />
    );
  });

  return (
    <div {...getTableBodyProps()} className="flex flex-col w-full">
      {rows}
    </div>
  );
};
